import LazySpinner from 'shared/components/molecules/LazySpinner/LazySpinner';

export default LazySpinner;
